import axios from 'axios';
import * as fileService from '../../services/common/file-service';
import { FileItem } from '../../services/common/file-service';
import { utilityService } from '../../services/common/utility-service';

export type FileFindQuery = {
    applicationName: string;
    divisionName: string;
    moduleName: string;
    folderName: string;
    fileName?: string;
    fileExtension?: string;
};

export type FileUploadCommand = {
    applicationName: string;
    divisionName: string;
    moduleName: string;
    folderName: string;
};

export const find = async (query: FileFindQuery): Promise<FileItem[]> => {
    return (await axios.get(`/api/v1/documents/find?${utilityService.toQueryString(query)}`)).data;
};

export const download = (id: string): void => {
    fileService.download({
        url: `/api/v1/documents/${id}`
    });
};

export const upload = async (command: FileUploadCommand, files: FileList): Promise<void> => {
    return (await fileService.upload({
        url: `/api/v1/documents/upload`,
        files: files,
        params: [
            { name: 'command', value: JSON.stringify(command) },
        ],
    }));
};

export const deleteFile = async (id: string): Promise<void> => {
    return await fileService.deleteFile({
        url: `/api/v1/documents/${id}`
    });
};
